import React from 'react';
import { 
  HelpCircle, 
  Utensils, 
  Activity, 
  Heart, 
  Clock, 
  Scale, 
  SmilePlus 
} from 'lucide-react';

/**
 * Компонент боковой панели с полезными советами
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Utensils,
      title: 'Питание для здорового WHR',
      description: 'Сократите потребление простых углеводов и увеличьте долю белка и полезных жиров.'
    },
    {
      icon: Activity,
      title: 'Физическая активность',
      description: 'Комбинируйте кардио и силовые тренировки для оптимального распределения жира в организме.'
    },
    {
      icon: Heart,
      title: 'Снижение рисков',
      description: 'Поддержание здорового WHR снижает риск сердечно-сосудистых заболеваний и диабета 2 типа.'
    },
    {
      icon: Clock,
      title: 'Регулярные измерения',
      description: 'Отслеживайте WHR раз в месяц для мониторинга прогресса и своевременной коррекции.'
    },
    {
      icon: Scale,
      title: 'Не только вес',
      description: 'WHR важнее, чем просто вес - он показывает распределение жира и связанные с этим риски.'
    },
    {
      icon: SmilePlus,
      title: 'Комплексный подход',
      description: 'Сочетайте правильное питание, физическую активность и здоровый сон для лучших результатов.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-emerald-500" />
        Полезные советы
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-emerald-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-100 dark:border-emerald-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-emerald-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-emerald-700 dark:text-emerald-300 mb-2">
              Индивидуальная консультация
            </h4>
            <p className="text-xs text-emerald-600 dark:text-emerald-400 mb-3">
              Для более точной оценки состояния здоровья рекомендуем обратиться к специалисту в области диетологии или эндокринологии.
            </p>
            <button className="w-full py-1.5 text-xs bg-emerald-500 text-white rounded hover:bg-emerald-600 transition-colors">
              Найти специалиста
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;